import React, { Fragment, useEffect, useState } from "react";
import { PlusOutlined } from "@ant-design/icons";
//import EmployeeRoles from "../utils/EmployeeRoles.json";
import henceforthApi from "../utils/henceforthApi";
import { GlobalContext } from "../context/Provider";
import { useNavigate } from "react-router-dom";
//import henceforthValidations from "../utils/henceforthValidations";
//import CountryCode from "../utils/CountryCode.json";
import {
  Button,
  Row,
  Col,
  Card,
  Typography,
  Modal,
  Input,
  Breadcrumb,
  Form,
  InputNumber,
  Select,
  Upload,
  message,
  DatePicker
} from "antd";
import ImgCrop from "antd-img-crop";
import GoogleMapComponent from "../components/GoogleMap";

const { Title } = Typography;
const { TextArea } = Input;
// const { Option } = Select;

const getBase64 = (file) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = (error) => reject(error);
  });

const genderOptions = [
  { value: "MALE", label: "Male" },
  { value: "FEMALE", label: "Female" },
  { value: "NO_PREFERENCE", label: "No Preference" },
];

const timerOptions = [
  { value: 6, label: "6" },
  { value: 12, label: "12" },
  { value: 24, label: "24" },
];

const raceOptions = [
  // { value: "MARATHON", label: "Marathon race" },
  { value: "QUICK_ADMIN", label: "Quick race" },
];

const AddRace = () => {
  const navigate = useNavigate();
  const { Toast, loading, setLoading } =
    React.useContext(GlobalContext);
  const [form] = Form.useForm();
  const [previewOpen, setPreviewOpen] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [fileList1, setFileList1] = useState([]);
  const [snapshotUrl, setSnapshotUrl] = useState(null);
  const [fileError, setFileError] = useState("");

  const defaultCenter = {
    lat: 30.704649,
    lng: 76.717873,
  };

  const [startAddress, setStartAddress] = useState(null);
  const [endAddress, setEndAddress] = useState(null);
  const [startPlace, setStartPlace] = useState(null);
  const [endPlace, setEndPlace] = useState(null);
  const [distance, setDistance] = useState(null);

  const raceType = Form.useWatch("race_type", form);

  const beforeUpload = (file) => {
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/jpg";
    console.log("isJpgOrPng", file.type);
    if (!isJpgOrPng) {
      setFileError("You can only upload JPG/PNG image!");
      return false;
    }
    const isLt1M = file.size / 1024 / 1024 < 2;
    console.log("isLt1M", file.size);
    if (!isLt1M) {    
      setFileError("Image must be smaller than 2MB!");
      return false;
    }
    return isJpgOrPng && isLt1M;
  };

  const handleCancel = () => setPreviewOpen(false);

  const handlePreview = async (file) => {
    if (!file.url && !file.preview) {
      file.preview = await getBase64(file.originFileObj);
    }
    setPreviewImage(file.url || file.preview);
    setPreviewOpen(true);
    setPreviewTitle(
      file.name || file.url.substring(file.url.lastIndexOf("/") + 1)
    );
  };

  console.log("startPlace", startPlace);

  const validateFile = (file) => {
    if (!file) return false;
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/jpg";
    const isLt1M = file.size / 1024 / 1024 < 1;
    return isJpgOrPng && isLt1M;
  };

  const handleChange1 = ({ fileList: newFileList, file }) => {
    // Clear error when fileList is empty
    if (newFileList.length === 0) {
      setFileList1([]);
      setFileError("");
      form.setFieldsValue({
        destination_banner: undefined,
      });
      return;
    }
    
    // Validate file and set error message
    if (file && file.originFileObj) {
      const fileObj = file.originFileObj;
      const isJpgOrPng = fileObj.type === "image/jpeg" || fileObj.type === "image/png" || fileObj.type === "image/jpg";
      const isLt1M = fileObj.size / 1024 / 1024 < 2;
      
      if (!isJpgOrPng) {
        setFileError("You can only upload JPG/PNG file!");
      } else if (!isLt1M) {
        setFileError("Image must be smaller than 2MB!");
      } else {
        setFileError("");
      }
    }
    
    // Always update fileList to allow file selection
    setFileList1(newFileList);
    form.setFieldsValue({
      destination_banner: newFileList[0],
    });
  };

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  const options = [];
  for (let i = 0; i < 10; i++) {
    options.push({
      value: i.toString(10) + i,
      label: i.toString(10) + i,
    });
  }

  useEffect(() => {
    if (form && distance) {
      form.setFieldsValue({ total_distance: distance / 1000 });
    }
  }, [form, distance]);

  const onFinish = async (values) => {
    const addressComponents1 = startPlace.address_components || [];
    const addressComponents2 = endPlace.address_components || [];

    const getComponent1 = (type) => {
      const component = addressComponents1.find((comp) =>
        comp.types.includes(type)
      );
      return component ? component.short_name : "";
    };

    const getComponent2 = (type) => {
      const component = addressComponents2.find((comp) =>
        comp.types.includes(type)
      );
      return component ? component.short_name : "";
    };

    let items = {
      title: String(values.title),
      max_participants: Number(values.max_participants),
      total_distance: Number(distance / 1000),
      race_type: String(values.race_type),
      race_stop_timer: Number(values.race_stop_timer),
      gender_preference: "NO_PREFERENCE",
      map_snapshot: String(snapshotUrl),
      start_location: {
        type: "Point",
        coordinates: [startAddress?.location?.lng, startAddress?.location?.lat],
      },
      start_location_name: startPlace?.name + "," + getComponent1("locality"),
      end_location: {
        type: "Point",
        coordinates: [endAddress?.location?.lng, endAddress?.location?.lat],
      },
      end_location_name: endPlace?.name + "," + getComponent2("locality"),
    };

    if (values.description) {
      items["description"] = String(values.description);
    }

    if (values.race_type === "MARATHON") {
      items["scheduled_time"] = new Date(values.scheduled_time).toISOString();
      items["remaining_completion_time"] = new Date(
        values.remaining_completion_time
      ).toISOString();
    }

    // Validate file before API call
    if (!values.destination_banner || !values.destination_banner.originFileObj) {
      Toast.error("Please upload a valid destination banner");
      setLoading(false);
      return;
    }

    // Check if there's a file error
    if (fileError) {
      Toast.error(fileError);
      setLoading(false);
      return;
    }

    const file = values.destination_banner.originFileObj;
    const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png" || file.type === "image/jpg";
    const isLt1M = file.size / 1024 / 1024 < 2;

    if (!isJpgOrPng) {
      setFileError("You can only upload JPG/PNG image!");
      setLoading(false);
      return;
    }

    if (!isLt1M) {
      setFileError("Image must be smaller than 2MB!");
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      let apiImageRes1 = await henceforthApi.Common.uploadFile(
        "file",
        values.destination_banner.originFileObj
      );
      items["destination_banner"] = apiImageRes1?.file_name;
      console.log(items, "Received values of form: ", apiImageRes1);
      let apiRes = await henceforthApi.Race.create(items);
      form.resetFields();
      setFileList1([]);
      setFileError("");
      Toast.success(apiRes?.message);
      // navigate(
      //   `/race/page/0?limit=10&race_type=${
      //     values.race_type === "MARATHON" ? "MARATHON" : "QUICK_ADMIN"
      //   }`
      // );
      navigate("/race")
    } catch (error) {
      Toast.error(error);
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  console.log("startPlace", startPlace);

  return (
    <Fragment>
      <section>
        <Row gutter={[20, 20]}>
          <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
            <Card className="common-card">
              <div className="mb-4">
                <Breadcrumb separator=">">
                  <Breadcrumb.Item>
                    <a href="/" className="text-decoration-none">
                      Home
                    </a>
                  </Breadcrumb.Item>
                  <Breadcrumb.Item>Race</Breadcrumb.Item>
                  <Breadcrumb.Item className="text-decoration-none">
                    Add Race
                  </Breadcrumb.Item>
                </Breadcrumb>
              </div>

              {/* Title */}
              <div className="mb-4">
                <Title level={3} className="m-0 fw-bold">
                  Add Race
                </Title>
              </div>

              {/* Form */}
              <div className="card-form-wrapper">
                <Form
                  form={form}
                  name="add_race"
                  className="add-staff-form"
                  onFinish={onFinish}
                  scrollToFirstError
                  layout="vertical"
                >
                  {/* Image */}
                  <Form.Item
                    name="destination_banner"
                    label="Destination Banner"
                    rules={[
                      {
                        required: true,
                        message: "Please upload Destination Banner",
                      },
                    ]}
                  >
                    <div>
                      <ImgCrop aspect={1}>
                        <Upload
                          customRequest={({ onSuccess }) => onSuccess("ok")}
                          name="destination_banner"
                          listType="picture-card"
                          fileList={fileList1}
                          onPreview={handlePreview}
                          beforeUpload={beforeUpload}
                          onChange={handleChange1}
                        >
                          {fileList1.length > 0 ? null : uploadButton}
                        </Upload>
                      </ImgCrop>
                      {console.log("fileError", fileError)}
                      {fileError && (
                        <div style={{ color: "#ff4d4f", fontSize: "14px", marginTop: "8px" }}>
                          {fileError}
                        </div>
                      )}
                    </div>
                  </Form.Item>

                  <Modal
                    open={previewOpen}
                    title={previewTitle}
                    footer={null}
                    onCancel={handleCancel}
                  >
                    <img
                      alt="example"
                      style={{ width: "100%" }}
                      src={previewImage}
                    />
                  </Modal>

                  {/* Name */}
                  <Form.Item
                    name="title"
                    rules={[
                      {
                        required: true,
                        whitespace: true,
                        message: "Please enter race title",
                      },
                    ]}
                    label="Title"
                  >
                    <Input placeholder="Enter Race title" />
                  </Form.Item>

                  <Form.Item
                    name="description"
                    rules={[
                      {
                        required: raceType === "MARATHON" ? true : false,
                        whitespace: true,
                        message: "Please enter race description",
                      },
                    ]}
                    label="Description"
                  >
                    <TextArea rows={4} placeholder="Enter Race description" />
                  </Form.Item>

                  <div className="h-[600px] w-100" style={{ height: "600px" }}>
                    <GoogleMapComponent
                      defaultCenter={defaultCenter}
                      setStartAddress={setStartAddress}
                      setEndAddress={setEndAddress}
                      setStartPlace={setStartPlace}
                      setEndPlace={setEndPlace}
                      setDistanced={setDistance}
                      setSnapshotUrl={setSnapshotUrl}
                    />
                  </div>

                  <Form.Item
                    name="max_participants"
                    label="Maximum Participants"
                    rules={[
                      {
                        required: true,
                        message: "Please enter number of maximum participants",
                      },
                      {
                        type: "number",
                        min: 3,
                        message: "Minimum 3 participants required",
                        transform: (value) => Number(value),
                      },
                    ]}
                  >
                    <InputNumber
                      min={3}
                      placeholder="Enter number of participants"
                      style={{ width: "40%" }}
                    />
                  </Form.Item>

                  <Form.Item name="total_distance" label="Total Distance(km.)">
                    <Input
                      placeholder="Enter total distance"
                      style={{ width: "40%" }}
                      disabled
                    />
                  </Form.Item>

                  <Form.Item
                    name="race_type"
                    label="Race Type"
                    rules={[{ required: true, message: "Please Select type" }]}
                  >
                    <Select
                      size={"large"}
                      placeholder="Please select"
                      style={{ width: "40%" }}
                      options={raceOptions.map((res) => {
                        return {
                          value: res.value,
                          label: res.label,
                        };
                      })}
                    />
                  </Form.Item>

                  {raceType === "MARATHON" && (
                    <Form.Item
                      name="scheduled_time"
                      label="Start Date & Time"
                      rules={[
                        {
                          required: raceType === "MARATHON" ? true : false,
                          message: "Please select date and time",
                        },
                      ]}
                    >
                      <DatePicker
                        showTime
                        format="YYYY-MM-DD HH:mm"
                        placeholder="Select date and time"
                        style={{ width: "40%" }}
                      />
                    </Form.Item>
                  )}

                  {raceType === "MARATHON" && (
                    <Form.Item
                      name="remaining_completion_time"
                      label="Completion Date & Time"
                      rules={[
                        {
                          required: raceType === "MARATHON" ? true : false,
                          message: "Please select date and time",
                        },
                      ]}
                    >
                      <DatePicker
                        showTime
                        format="YYYY-MM-DD HH:mm"
                        placeholder="Select date and time"
                        style={{ width: "40%" }}
                      />
                    </Form.Item>
                  )}

                  <Form.Item
                    name="race_stop_timer"
                    label="Race Stop Timer"
                    rules={[{ required: true, message: "Please Select time" }]}
                  >
                    <Select
                      size={"large"}
                      placeholder="Please select"
                      style={{ width: "40%" }}
                      options={timerOptions.map((res) => {
                        return {
                          value: res.value,
                          label: res.label,
                        };
                      })}
                    />
                  </Form.Item>

                  {/* <Form.Item
                    name="gender_preference"
                    label="Gender Preference"
                    rules={[
                      { required: true, message: "Please Select gender" },
                    ]}
                  >
                    <Select
                      size={"large"}
                      placeholder="Please select"
                      style={{ width: "40%" }}
                      options={genderOptions.map((res) => {
                        return {
                          value: res.value,
                          label: res.label,
                        };
                      })}
                    />
                  </Form.Item> */}

                  {/* Button */}
                  <Button
                    htmlType="submit"
                    loading={loading}
                    className=" w-100 border-none hover:!bg-[#1a1a1a] !text-white"
                    style={{
                      backgroundColor: 'black',
                      color: 'white',
                      border: 'none',
                      width: '100%',
                      transition: 'background-color 0.3s ease',
                    }}
                  >
                    Add Race
                  </Button>
                </Form>
              </div>
            </Card>
          </Col>
        </Row>
      </section>
    </Fragment>
  );
};

export default AddRace;